import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { useGoogle } from '../../../context/GoogleProvider';

const propTypes = {
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  zoomLevel: PropTypes.number,
};

const defaultProps = {
  latitude: 0,
  longitude: 0,
  zoomLevel: 1,
};

function GoogleMapComponent({ latitude, longitude, zoomLevel }) {
  const { scriptReady, googleMapStyleId } = useGoogle();

  if (!scriptReady) {
    return null;
  }

  return (
    <GoogleMap
      mapContainerStyle={{ width: '100%', minHeight: '400px' }}
      center={{ lat: latitude, lng: longitude }}
      zoom={zoomLevel}
      options={{ mapId: googleMapStyleId }}
    >
      <Marker position={{ lat: latitude, lng: longitude }} />
    </GoogleMap>
  );
}

GoogleMapComponent.propTypes = propTypes;
GoogleMapComponent.defaultProps = defaultProps;

export default GoogleMapComponent;
